import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { selectValidateChildrenAreRequired } from '@newStore/validation/validationRules/childrenAreRequired';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const CONTACT_GROUP: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  validationRules: [selectCurriculumThemesValidation, selectValidateChildrenAreRequired],
  information: {
    single: 'Contactgroep',
    plural: 'Contactgroepen',
    ribonIcon: require('../../../../img/buildingBlocks/CONTACT_GROUP.svg'),
  },
  buildingBlocks: [{ type: NodeType.PERSON_REFERENCE }],
  edit: [],
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default CONTACT_GROUP;
